var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueesdetox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 311.306,
    height: 155.038,
    viewBox: "0 0 311.306 155.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#6a841e;}.c{filter:url(#w);}.d{filter:url(#u);}.e{filter:url(#s);}.f{filter:url(#q);}.g{filter:url(#o);}.h{filter:url(#m);}.i{filter:url(#k);}.j{filter:url(#i);}.k{filter:url(#g);}.l{filter:url(#e);}.m{filter:url(#c);}.n{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 20.59,
    width: 46.68,
    height: 65.096,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 33.958,
    y: 13.572,
    width: 62.313,
    height: 70.838,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 85.405,
    y: 14.181,
    width: 54.047,
    height: 61.761,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 130.093,
    y: 0,
    width: 49.262,
    height: 75.246,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 186.468,
    y: 14.181,
    width: 49.262,
    height: 61.065,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 222.63,
    y: 13.427,
    width: 51.031,
    height: 62.37,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 0.161,
    y: 82.75,
    width: 64.872,
    height: 71.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 56.428,
    y: 82.786,
    width: 57.744,
    height: 71.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 102.112,
    y: 82.786,
    width: 60.156,
    height: 71.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 147.254,
    y: 81.994,
    width: 73.08,
    height: 73.044,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "t"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "t"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    x: 202.803,
    y: 82.75,
    width: 68.477,
    height: 71.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "v"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "v"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    x: 257.126,
    y: 76.234,
    width: 54.18,
    height: 78.012,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "x"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "x"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521.264 -417.597)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M540.82,459.384a6.651,6.651,0,0,1,.087-1.188,1.672,1.672,0,0,1,.29-.726.968.968,0,0,1,.536-.348,3.378,3.378,0,0,1,.826-.087h4.9a1.232,1.232,0,0,1,1,.435,1.5,1.5,0,0,1,.363.986q0,2.552-.073,4.423a8.2,8.2,0,0,1-.565,2.972,8.326,8.326,0,0,1-1.74,2.335,19.141,19.141,0,0,1-2.2,1.768q-1.16.8-2.32,1.508a13.392,13.392,0,0,0-2.087,1.566,7.206,7.206,0,0,0-1.508,1.958,5.659,5.659,0,0,0-.58,2.667,5.779,5.779,0,0,0,.536,2.479,6.365,6.365,0,0,0,1.465,2,7.042,7.042,0,0,0,4.784,1.842,5.619,5.619,0,0,0,2.378-.493,6.758,6.758,0,0,0,1.885-1.276,7.161,7.161,0,0,0,1.348-1.784,7.978,7.978,0,0,0,.769-2.044,4.951,4.951,0,0,1,.942-1.87,2.321,2.321,0,0,1,1.755-.855h4.03a1.146,1.146,0,0,1,.986.362,1.728,1.728,0,0,1,.32.768v.841a13.194,13.194,0,0,1-1.2,5.507,13.567,13.567,0,0,1-3.146,4.324,14.448,14.448,0,0,1-4.582,2.817,15.041,15.041,0,0,1-5.481,1.011,15.207,15.207,0,0,1-5.451-.982,14.475,14.475,0,0,1-4.539-2.73,13.116,13.116,0,0,1-3.117-4.179,12.155,12.155,0,0,1-1.16-5.3,13.47,13.47,0,0,1,.783-4.915A11.8,11.8,0,0,1,533,469.81a13.2,13.2,0,0,1,2.538-2.32q1.362-.942,2.537-1.8a10.8,10.8,0,0,0,1.958-1.8,3.488,3.488,0,0,0,.783-2.306Zm7.859-9.6a3.973,3.973,0,0,1-.218,1.392.993.993,0,0,1-1.058.58h-4.554c-.232,0-.468-.01-.71-.029a2.1,2.1,0,0,1-.667-.159,1.318,1.318,0,0,1-.507-.377,1.089,1.089,0,0,1-.2-.711v-4.292c0-.271.009-.522.029-.754a1.929,1.929,0,0,1,.159-.638.988.988,0,0,1,.392-.449,1.4,1.4,0,0,1,.725-.16h4.553a4.16,4.16,0,0,1,1.537.218q.522.216.522,1.087Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M564.222,459.354a22.073,22.073,0,0,1,3.016-11.194,22.7,22.7,0,0,1,3.466-4.495,21.682,21.682,0,0,1,4.48-3.466,22.74,22.74,0,0,1,5.293-2.233,22.14,22.14,0,0,1,11.774,0,22.759,22.759,0,0,1,5.293,2.233,22.127,22.127,0,0,1,7.96,7.961,22.7,22.7,0,0,1,2.233,5.307,22.379,22.379,0,0,1-.1,12.209,22.516,22.516,0,0,1-2.527,5.6,21.477,21.477,0,0,1-3.907,4.611,21.806,21.806,0,0,1-5.039,3.364,18.524,18.524,0,0,1-2.775,1.059q-1.438.42-2.919.739v7.685a1.212,1.212,0,0,1-1.386,1.276h-5.723a1.138,1.138,0,0,1-1.271-1.3v-7.685q-.843-.2-1.654-.464t-1.565-.58a4.212,4.212,0,0,1-.842-.131,5.737,5.737,0,0,1-.782-.275,21.689,21.689,0,0,1-9.411-7.96,21.977,21.977,0,0,1-2.668-5.728A22.3,22.3,0,0,1,564.222,459.354Zm8.381-.058a14.155,14.155,0,0,0,1.059,5.481,13.89,13.89,0,0,0,2.9,4.437,13.742,13.742,0,0,0,4.35,2.987,13.894,13.894,0,0,0,10.846,0,13.934,13.934,0,0,0,4.365-2.987,13.793,13.793,0,0,0,2.914-4.437,14.651,14.651,0,0,0,0-10.933,13.965,13.965,0,0,0-2.914-4.451,13.811,13.811,0,0,0-4.365-3,13.894,13.894,0,0,0-10.846,0,13.622,13.622,0,0,0-4.35,3,14.177,14.177,0,0,0-3.959,9.9Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M624.136,463.356a12.925,12.925,0,0,0,.7,4.379,9.378,9.378,0,0,0,1.957,3.292,8.392,8.392,0,0,0,3.016,2.058,10.276,10.276,0,0,0,3.9.711,10.4,10.4,0,0,0,4.059-.754,8.322,8.322,0,0,0,3.032-2.132,9.411,9.411,0,0,0,1.884-3.3,13.192,13.192,0,0,0,.653-4.249v-24.3a1.229,1.229,0,0,1,.376-.9,1.289,1.289,0,0,1,.953-.377h5.606a1.483,1.483,0,0,1,1.027.377,1.172,1.172,0,0,1,.419.9v24.621a19.62,19.62,0,0,1-1.45,7.845,15.653,15.653,0,0,1-9.648,8.917,21.589,21.589,0,0,1-6.926,1.1,20.359,20.359,0,0,1-6.926-1.174,16.767,16.767,0,0,1-5.737-3.437,16.306,16.306,0,0,1-3.912-5.6,19.051,19.051,0,0,1-1.448-7.656V439.054a1.345,1.345,0,0,1,.334-.87,1.053,1.053,0,0,1,.855-.406h5.916a1.449,1.449,0,0,1,.9.377,1.128,1.128,0,0,1,.463.9Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M660.357,439.17q0-1.392,1.276-1.392h27.956a1.263,1.263,0,0,1,1.073.422,1.711,1.711,0,0,1,.319,1.063v5.122a1.365,1.365,0,0,1-.362.932,1.385,1.385,0,0,1-1.088.407H668.912v8.787H684.8a1.179,1.179,0,0,1,.929.246,1.311,1.311,0,0,1,.348,1.03v5.249a1.557,1.557,0,0,1-.29.928,1.062,1.062,0,0,1-.928.406h-15.95V472.9h21.373a1.294,1.294,0,0,1,1.073.349,1.806,1.806,0,0,1,.261,1.078v5.3q0,1.224-1.277,1.223H661.633a1.432,1.432,0,0,1-.9-.29,1.1,1.1,0,0,1-.377-.928Zm15.109-14.355a1.848,1.848,0,0,1,.653-.928,1.574,1.574,0,0,1,.913-.29h5.162a.825.825,0,0,1,.652.218.787.787,0,0,1,.189.536,3.283,3.283,0,0,1-.044.508,2.112,2.112,0,0,1-.159.536l-2.755,6.148a1.709,1.709,0,0,1-1.537,1.218h-4.524q-.493,0-.638-.232a1.016,1.016,0,0,1-.145-.551c0-.193.01-.387.028-.58a1.964,1.964,0,0,1,.175-.609Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M716.732,439.17q0-1.392,1.276-1.392h27.956a1.263,1.263,0,0,1,1.073.422,1.711,1.711,0,0,1,.319,1.063v5.122a1.365,1.365,0,0,1-.362.932,1.385,1.385,0,0,1-1.088.407H725.287v8.787h15.891a1.179,1.179,0,0,1,.929.246,1.311,1.311,0,0,1,.348,1.03v5.249a1.557,1.557,0,0,1-.29.928,1.062,1.062,0,0,1-.928.406h-15.95V472.9H746.66a1.294,1.294,0,0,1,1.073.349,1.806,1.806,0,0,1,.261,1.078v5.3q0,1.224-1.277,1.223H718.008a1.432,1.432,0,0,1-.9-.29,1.1,1.1,0,0,1-.377-.928Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M779.429,449.262a1.349,1.349,0,0,1-.7-.188,6.7,6.7,0,0,1-.725-.508l-.058-.029a15.178,15.178,0,0,0-3.363-2.465,14.286,14.286,0,0,0-2.306-.986,7.992,7.992,0,0,0-2.509-.406,10.331,10.331,0,0,0-2.871.362,6.552,6.552,0,0,0-2.088.987,4.27,4.27,0,0,0-1.276,1.464,3.871,3.871,0,0,0-.435,1.8,2.768,2.768,0,0,0,.653,1.827,6,6,0,0,0,1.769,1.392,17.26,17.26,0,0,0,2.567,1.116q1.448.508,3.044,1,1.827.55,3.625,1.189a33.371,33.371,0,0,1,3.437,1.435,24.244,24.244,0,0,1,3.06,1.77,11.576,11.576,0,0,1,2.45,2.232,10.21,10.21,0,0,1,1.624,2.814,9.71,9.71,0,0,1,.594,3.494,12.592,12.592,0,0,1-1.276,5.713,13.028,13.028,0,0,1-3.523,4.365,16.167,16.167,0,0,1-5.279,2.783,21.192,21.192,0,0,1-6.509.972,19.188,19.188,0,0,1-4.438-.522,21.427,21.427,0,0,1-4.233-1.479,22.391,22.391,0,0,1-3.843-2.306,19.129,19.129,0,0,1-3.233-3.03v.029l-.059-.116a2.115,2.115,0,0,1-.638-1.334,1.167,1.167,0,0,1,.174-.609,3.431,3.431,0,0,1,.523-.638l.957-.957c.29-.251.6-.531.927-.841a12.523,12.523,0,0,1,.987-.841q.492-.377.913-.638a1.412,1.412,0,0,1,.681-.261,1.23,1.23,0,0,1,.754.261,5.341,5.341,0,0,1,.58.493l.117.116h-.03a19.231,19.231,0,0,0,2.277,1.827,22.891,22.891,0,0,0,2.595,1.552A15.579,15.579,0,0,0,767,473.172a8.7,8.7,0,0,0,2.479.392,10.6,10.6,0,0,0,2.987-.406,7.746,7.746,0,0,0,2.408-1.145,5.5,5.5,0,0,0,1.594-1.784,4.692,4.692,0,0,0,.58-2.32,3.33,3.33,0,0,0-.753-2.189,6.882,6.882,0,0,0-1.973-1.6,15.252,15.252,0,0,0-2.74-1.174q-1.523-.494-3.06-.928a46.116,46.116,0,0,1-6.191-2.32,18.8,18.8,0,0,1-4.423-2.8,10.384,10.384,0,0,1-2.653-3.481,10.272,10.272,0,0,1-.884-4.335,10.774,10.774,0,0,1,4.176-8.715,14.89,14.89,0,0,1,4.813-2.465,20.953,20.953,0,0,1,6.293-.884,18.389,18.389,0,0,1,5.365.827,20.908,20.908,0,0,1,5.046,2.276q.7.435,1.421.986t1.334,1.117a7.856,7.856,0,0,1,1,1.1,1.671,1.671,0,0,1,.392.914,1.644,1.644,0,0,1-.174.71,2.718,2.718,0,0,1-.436.653l-.87.928v-.029l-.9.957a11.479,11.479,0,0,1-.929.885q-.465.391-.841.652A1.2,1.2,0,0,1,779.429,449.262Z",
    transform: "translate(-521.26 -417.6)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M577.3,533.167a26.583,26.583,0,0,1-.972,7.254,25.89,25.89,0,0,1-2.773,6.408,26.656,26.656,0,0,1-9.845,9.486,27.905,27.905,0,0,1-6.57,2.61,28.909,28.909,0,0,1-7.308.918H532.081a2.277,2.277,0,0,1-1.152-.288,1.29,1.29,0,0,1-.5-1.224V508.039a1.779,1.779,0,0,1,.414-1.224,1.57,1.57,0,0,1,1.242-.468h17.748a28.173,28.173,0,0,1,7.29.936,27.619,27.619,0,0,1,6.552,2.664,28.144,28.144,0,0,1,5.562,4.14,25.631,25.631,0,0,1,4.3,5.4,27.133,27.133,0,0,1,2.771,6.444A26.15,26.15,0,0,1,577.3,533.167Zm-32.94-13.9v27.684h3.024c.552,0,1.091-.018,1.62-.054s1.056-.077,1.584-.126a14.46,14.46,0,0,0,5.04-1.314,13.975,13.975,0,0,0,4.086-2.88,12.965,12.965,0,0,0,2.736-4.194,13.7,13.7,0,0,0,.99-5.256,13.482,13.482,0,0,0-1.134-5.562,13.752,13.752,0,0,0-3.078-4.392,13.9,13.9,0,0,0-4.554-2.88,15.072,15.072,0,0,0-5.562-1.026Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M586.692,508.039a1.716,1.716,0,0,1,.413-1.206,1.5,1.5,0,0,1,1.167-.45h35.716a1.589,1.589,0,0,1,1.225.467,1.779,1.779,0,0,1,.431,1.256v8.9a1.881,1.881,0,0,1-.431,1.167,1.5,1.5,0,0,1-1.261.556H600.624v8.928h18a1.892,1.892,0,0,1,1.134.324,1.24,1.24,0,0,1,.45,1.08v7.776a1.492,1.492,0,0,1-.4.972,1.425,1.425,0,0,1-1.152.468H600.624v9.216h24.192a1.446,1.446,0,0,1,1.62,1.651v9.046a.889.889,0,0,1-.288.646q-.144,1-1.475,1.005h-36.4a1.679,1.679,0,0,1-1.149-.378,1.476,1.476,0,0,1-.431-1.17Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M632.376,507.962a1.461,1.461,0,0,1,.486-1.148,1.753,1.753,0,0,1,1.206-.431H672.8a1.819,1.819,0,0,1,1.153.4,1.613,1.613,0,0,1,.576,1.184V516.9a2.022,2.022,0,0,1-.45,1.239,1.515,1.515,0,0,1-1.279.592h-12.42V558.15a1.715,1.715,0,0,1-.466,1.171,1.561,1.561,0,0,1-1.221.522H648.139a1.692,1.692,0,0,1-1.149-.486,1.565,1.565,0,0,1-.538-1.207V518.731H634.068a1.677,1.677,0,0,1-1.206-.466,1.809,1.809,0,0,1-.486-1.365Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M677.518,533.167a27.359,27.359,0,0,1,3.747-13.914,27.885,27.885,0,0,1,4.3-5.6,26.863,26.863,0,0,1,5.565-4.3,28.235,28.235,0,0,1,6.575-2.772,27.568,27.568,0,0,1,14.643,0,28.173,28.173,0,0,1,6.593,2.772,27.34,27.34,0,0,1,9.889,9.9,28.571,28.571,0,0,1,2.773,6.588,27.6,27.6,0,0,1,0,14.652,27.868,27.868,0,0,1-2.773,6.552,27.072,27.072,0,0,1-4.3,5.544,28.151,28.151,0,0,1-5.584,4.3,27.564,27.564,0,0,1-27.811,0,27.907,27.907,0,0,1-9.87-9.846,26.862,26.862,0,0,1-2.774-6.552A27.284,27.284,0,0,1,677.518,533.167Zm13.933-.036a15.281,15.281,0,0,0,1.006,5.58,13.764,13.764,0,0,0,2.823,4.518,13.155,13.155,0,0,0,4.3,3.024,14.191,14.191,0,0,0,10.947,0,13.1,13.1,0,0,0,4.315-3.024,13.761,13.761,0,0,0,2.822-4.518,15.913,15.913,0,0,0,0-11.142,13.935,13.935,0,0,0-2.822-4.554,13.415,13.415,0,0,0-19.558,0,13.937,13.937,0,0,0-2.823,4.554A15.328,15.328,0,0,0,691.451,533.131Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M733.139,558.907q.288-.54.594-1.1a13.286,13.286,0,0,1,.7-1.134l16.2-24.192q-4.14-6.228-8.19-12.312t-8.189-12.312a3.48,3.48,0,0,1-.343-.54,1.625,1.625,0,0,1-.161-.54.351.351,0,0,1,.413-.27,1.385,1.385,0,0,0,.7-.162H747.4a2.311,2.311,0,0,1,2.088,1.368l8.82,13.248,8.928-13.248a2.311,2.311,0,0,1,2.088-1.368h11.988q.4,0,.739.019a1.712,1.712,0,0,1,.593.125.35.35,0,0,1,.252.324,1.559,1.559,0,0,1-.4.936l-16.56,24.732,16.884,25.2a6.426,6.426,0,0,1,.559.918,1.325,1.325,0,0,1,.161.7q0,.54-.648.54H770a1.875,1.875,0,0,1-1.117-.36,2.437,2.437,0,0,1-.792-.972L758.3,544l-9.684,14.508a2.454,2.454,0,0,1-.792.972,1.876,1.876,0,0,1-1.115.36H733.787a.815.815,0,0,1-.5-.162.53.53,0,0,1-.216-.45A.718.718,0,0,1,733.139,558.907Z",
    transform: "translate(-521.26 -417.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 521.26, 417.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M811.474,536.263a21.371,21.371,0,0,1-.091,2.232,2.876,2.876,0,0,1-.358,1.242,1.186,1.186,0,0,1-.79.522,7.072,7.072,0,0,1-1.382.108h-8.4a1.47,1.47,0,0,1-1.221-.54,1.906,1.906,0,0,1-.431-1.224q0-1.908.053-3.348t.162-2.52a12.9,12.9,0,0,1,.287-1.8,4.289,4.289,0,0,1,.467-1.188,11.334,11.334,0,0,1,2.279-2.7,20.722,20.722,0,0,1,2.6-1.89q1.328-.81,2.62-1.494a12.97,12.97,0,0,0,2.28-1.512,6.644,6.644,0,0,0,1.6-1.962,5.921,5.921,0,0,0,.61-2.826,5.235,5.235,0,0,0-.5-2.232,6.5,6.5,0,0,0-1.346-1.908,6.4,6.4,0,0,0-1.974-1.314,5.9,5.9,0,0,0-2.351-.486,5.587,5.587,0,0,0-2.333.5,6.673,6.673,0,0,0-3.338,3.348,5.539,5.539,0,0,0-.5,2.3v.828a.959.959,0,0,1-.432.882,2.548,2.548,0,0,1-1.08.342,8.6,8.6,0,0,1-1.386.036c-.492-.023-.93-.036-1.314-.036h-6.228a1.418,1.418,0,0,1-1.242-.486,1.7,1.7,0,0,1-.342-.99v-1.188a15.964,15.964,0,0,1,1.493-6.93,17.148,17.148,0,0,1,3.992-5.418,18.215,18.215,0,0,1,5.79-3.528,19.091,19.091,0,0,1,6.887-1.26,18.354,18.354,0,0,1,6.977,1.332,18.055,18.055,0,0,1,5.736,3.69,18.024,18.024,0,0,1,4.783,17.082,13.394,13.394,0,0,1-1.368,3.33,11.093,11.093,0,0,1-1.944,2.448,22.16,22.16,0,0,1-2.232,1.836q-1.134.81-2.214,1.494a14.568,14.568,0,0,0-1.926,1.44A6.773,6.773,0,0,0,812,534.139,4.165,4.165,0,0,0,811.474,536.263Zm-12.6,13.212a1.638,1.638,0,0,1,.395-1.151,1.523,1.523,0,0,1,1.185-.433h9.476a1.729,1.729,0,0,1,1.131.433,1.418,1.418,0,0,1,.521,1.151v8.712a1.769,1.769,0,0,1-.413,1.152,1.51,1.51,0,0,1-1.239.5h-9.476q-1.581,0-1.58-1.656Z",
    transform: "translate(-521.26 -417.6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueesdetox);
export default __webpack_public_path__ + "static/media/queesdetox.4230c8ded585af7d64b9be911c0cc697.svg";
export { ForwardRef as ReactComponent };